import { mountRaceList } from './utils/mount-race-list.js';
import { LA_COUNTY_URL } from './constants.js';
import { SHARED_RACES } from './shared-races.js';
import { getSeatNumber } from './utils/race-helpers.js';

// first parameter here needs to match what's in the multipleRaces js file
mountRaceList('la-county-judges-races', LA_COUNTY_URL, {
  // filter options: FilterSpec in stores.js
  filter: [
    {
      tagsAny: ['judge', 'superior court'],
      excludeIds: SHARED_RACES.map((race) => race.lavote),
      sort: 'seat',
    },
  ],
  component: 'result', // to show 2 col table
  // captionField: 'jurisdiction',
  captions: {
    'judge-of-the-superior-court-office-no-64-4348': 'Office 64',
    'judge-of-the-superior-court-office-no-65-4348': 'Office 65',
    'judge-of-the-superior-court-office-no-87-4348': 'Office 87',
    'judge-of-the-superior-court-office-no-131-4348': 'Office 131',
  },
  // Shows AP's race in place of L.A. Vote's for the ones set to 'ap'
  sharedRaces: SHARED_RACES,
}).catch(console.error);
